import { useId } from 'react';

/**
 * The DevRobot mark (UI kit): the bracket robot of `assets/DevRobot_iso_blink.svg`,
 * painted with the dusk gradient of the theme. Its eyes blink now and then (`.dr-eyes`).
 * The artwork is 212.5 x 250; the group centres it in a square box so every `size-*` fits.
 */
export function RobotMark({ className = 'size-9' }: { className?: string }) {
  const id = `dr-logo-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
  return (
    <svg viewBox="0 0 250 250" className={`${className} shrink-0`} aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={id} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="212.5" y2="250">
          <stop offset="0" style={{ stopColor: 'var(--color-primary)' }} />
          <stop offset="0.62" style={{ stopColor: 'var(--color-secondary)' }} />
          <stop offset="1" style={{ stopColor: 'var(--color-accent)' }} />
        </linearGradient>
      </defs>
      <g transform="translate(18.75 0)" fill={`url(#${id})`}>
        <path d="M198.4,62.2c-9.7-12.3-23.6-19.4-37.9-19.4h-13.3v29.6h13.3c12.1,0,22.4,14.7,22.4,32.2v40.6c0,17.4-10.2,32.2-22.4,32.2h-65.6s.1,29.5.1,29.5l43.1,43.1,20.9-20.9-22-22h23.4c14.3,0,28.2-7.1,37.9-19.4,9.1-11.5,14.1-26.5,14.1-42.4v-40.6c0-15.9-5-30.9-14.1-42.4Z" />
        <path d="M29.6,145v-40.6c0-17.4,10.2-32.2,22.4-32.2h36s26.6,0,26.6,0h3.1s0-.1,0-.1V0h-29.6v42.8h-36c-14.3,0-28.2,7-37.9,19.3C5,73.5,0,88.5,0,104.4v40.6c0,15.9,5,30.9,14.1,42.4,9.7,12.3,23.6,19.4,37.9,19.4h13.3v-29.6h-13.3c-12.1,0-22.4-14.7-22.4-32.2Z" />
        <g className="dr-eyes">
          <rect x="64.6" y="111.5" width="29.6" height="29.6" />
          <rect x="117.6" y="111.5" width="29.6" height="29.6" />
        </g>
      </g>
    </svg>
  );
}

export function Wordmark({ sub = 'Platform' }: { sub?: string }) {
  return (
    <span className="leading-none">
      <span className="block text-[15px] font-bold tracking-tight">DevRobot</span>
      <span className="mt-1 block text-[11px] font-medium text-base-content/50">{sub}</span>
    </span>
  );
}

export function Logo({ className = '' }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <RobotMark className="size-9" />
      <Wordmark />
    </span>
  );
}
